// Localized strings for the blog module
const blog = {
  uk: {
    title: 'Блог',
    subtitle: 'Свіжа аналітика зі вступу за кордон',
    readMore: 'Читати →',
    empty: 'Ще немає публікацій',
    back: '← До всіх статей',
    updated: 'Оновлено',
    reviewed: 'Перевірено',
    sources: 'Джерела',
    nextPage: 'Наступна →',
    prevPage: '← Попередня',
    page: 'Сторінка',
  },
  en: {
    title: 'Blog',
    subtitle: 'Fresh analysis on studying abroad',
    readMore: 'Read →',
    empty: 'No posts yet',
    back: '← All articles',
    updated: 'Updated',
    reviewed: 'Reviewed by',
    sources: 'Sources',
    nextPage: 'Next →',
    prevPage: '← Previous',
    page: 'Page',
  },
  ru: {
    title: 'Блог',
    subtitle: 'Свежая аналитика по обучению за границей',
    readMore: 'Читать →',
    empty: 'Публикаций пока нет',
    back: '← Ко всем статьям',
    updated: 'Обновлено',
    reviewed: 'Проверено',
    sources: 'Источники',
    nextPage: 'Следующая →',
    prevPage: '← Предыдущая',
    page: 'Страница',
  },
  pl: {
    title: 'Blog',
    subtitle: 'Świeże analizy studiów za granicą',
    readMore: 'Czytaj →',
    empty: 'Brak publikacji',
    back: '← Wszystkie artykuły',
    updated: 'Zaktualizowano',
    reviewed: 'Sprawdzone przez',
    sources: 'Źródła',
    nextPage: 'Następna →',
    prevPage: '← Poprzednia',
    page: 'Strona',
  },
  it: {
    title: 'Blog',
    subtitle: 'Analisi aggiornate sullo studio all\'estero',
    readMore: 'Leggi →',
    empty: 'Nessun articolo',
    back: '← Tutti gli articoli',
    updated: 'Aggiornato',
    reviewed: 'Revisionato da',
    sources: 'Fonti',
    nextPage: 'Successiva →',
    prevPage: '← Precedente',
    page: 'Pagina',
  },
  es: {
    title: 'Blog',
    subtitle: 'Análisis actualizado sobre estudios en el extranjero',
    readMore: 'Leer →',
    empty: 'Aún no hay publicaciones',
    back: '← Todos los artículos',
    updated: 'Actualizado',
    reviewed: 'Revisado por',
    sources: 'Fuentes',
    nextPage: 'Siguiente →',
    prevPage: '← Anterior',
    page: 'Página',
  },
  ar: {
    title: 'المدونة',
    subtitle: 'تحليل حديث للدراسة في الخارج',
    readMore: 'قراءة ←',
    empty: 'لا توجد منشورات بعد',
    back: 'جميع المقالات ←',
    updated: 'محدّث',
    reviewed: 'مراجعة',
    sources: 'المصادر',
    nextPage: 'التالية ←',
    prevPage: '← السابقة',
    page: 'صفحة',
  },
  zh: {
    title: '博客',
    subtitle: '出国留学最新分析',
    readMore: '阅读 →',
    empty: '暂无文章',
    back: '← 所有文章',
    updated: '更新',
    reviewed: '审核',
    sources: '来源',
    nextPage: '下一页 →',
    prevPage: '← 上一页',
    page: '页',
  },
};

// URL segment mapping (uk → ua for user preference)
export const LOCALE_TO_URL_SEG = {
  uk: 'ua', en: 'en', ru: 'ru', pl: 'pl',
  it: 'it', es: 'es', ar: 'ar', zh: 'zh',
};

// hreflang value per locale (Google format)
export const LOCALE_TO_HREFLANG = {
  uk: 'uk', en: 'en', ru: 'ru', pl: 'pl',
  it: 'it', es: 'es', ar: 'ar', zh: 'zh-Hans',
};

// html lang value
export const LOCALE_TO_HTML_LANG = {
  uk: 'uk', en: 'en', ru: 'ru', pl: 'pl',
  it: 'it', es: 'es', ar: 'ar', zh: 'zh-Hans',
};

export const blogI18n = blog;
export default blog;
